export default "data:video/mp2t;base64,aW1wb3J0IHsgYXRvbSB9IGZyb20gJ2pvdGFpJwoKZXhwb3J0IGNvbnN0IG9yZ2FuaXphdGlvbkxvYWRpbmdBdG9tID0gYXRvbShmYWxzZSkK"